export default __webpack_public_path__ + "static/focus-blocks-55490a6a06505ca72a1fea2e311ad2e5.svg";